module.exports = __webpack_public_path__ + "static/media/2-d.0879cc0e.png";